// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".create-edit-obj-box[data-v-670cdcbf]{height:92%;overflow:auto}.create-edit-obj[data-v-670cdcbf]{padding:0 20px 0 20px;margin-bottom:20px;background:#fff!important;min-height:100%}[data-v-670cdcbf] .buttons{text-align:center;position:fixed;bottom:50px;width:100%}[data-v-670cdcbf] .buttons .el-button-group .el-button{margin-right:20px!important}", ""]);
// Exports
module.exports = exports;
